import { FC, useState } from 'react';

import CommonButton from 'components/CommonButton/CommonButton';
import PaymentSettingsDrawer from './PaymentSettingsDrawer/PaymentSettingsDrawer';
import PaymentStats from './PaymentStats/PaymentStats';
import AppointmentHoldsTable from './AppointmentHoldsTable/AppointmentHoldsTable';
import useStripeStatus from 'hooks/useStripeStatus';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { Navigate } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';
import { isStripeSetupComplete } from 'utils/isStripeSetupComplete';

interface PaymentAuthorizationsPageProps {}

const PaymentAuthorizationsPage: FC<PaymentAuthorizationsPageProps> = () => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const { data, isLoading } = useStripeStatus();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isStripeSetupComplete(data)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return (
    <div className="pt-2.4 pl-3 pr-4 text-14 leading-[2.1rem]">
      <div className="flex items-center justify-between gap-x-3">
        <h3 className="text-24 font-bold leading-[3.6rem]">
          Payment Authorizations
        </h3>
        <CommonButton
          variant="secondary"
          onClick={() => setIsSettingsOpen(true)}
        >
          Settings
        </CommonButton>
      </div>

      <div className="mt-2.4">
        <PaymentStats />
      </div>

      <div className="mt-2.4 mb-2.4 bg-white rounded-[1rem] border border-light-grey shadow-elevation-07">
        <AppointmentHoldsTable />
      </div>

      <PaymentSettingsDrawer
        isShowing={isSettingsOpen}
        setIsShowing={setIsSettingsOpen}
      />
    </div>
  );
};

export default PaymentAuthorizationsPage;
